import React, { useState, useEffect, useContext } from 'react';
import { AudioContext } from '../../context/AudioContext';
import { useNavigate } from 'react-router-dom';
import { BASE_URL } from "../../config/config";
import { Link } from 'react-router-dom';

const LikedChannels = () => {
    const [history, setHistory] = useState([]);
    const [likedChannels, setLikedChannels] = useState([]);
    const [loading, setLoading] = useState(true);
    const { setCurrentChannel } = useContext(AudioContext);
    const navigate = useNavigate();

    useEffect(() => {
        const token = localStorage.getItem('token');

        if (!token) {
            navigate('/signin'); // Redirect to login if not authenticated
            return;
        }

        fetch(`${BASE_URL}/liked-channels`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        })
        .then(response => {
            if (response.status === 401) {
                navigate('/signin'); // Redirect if unauthorized
                return;
            }
            return response.json();
        })
        .then(data => {
            setLikedChannels(data);
            setLoading(false);
        })
        .catch(error => console.error('Error fetching liked channels:', error));
    }, [navigate]);

    const playChannel = (channel) => {
        setCurrentChannel(channel);

        // Update history
        let updatedHistory = [channel, ...history.filter(item => item.id !== channel.id)];
        if (updatedHistory.length) updatedHistory.pop();

        setHistory(updatedHistory);
        sessionStorage.setItem('radioHistory', JSON.stringify(updatedHistory));
    };

    if (loading) return <p>Loading liked channels...</p>;

    return (
        <main className="main">
            <div className="container-fluid">
                <section className="row row--grid">
                    <div className="col-12">
                        <div className="main__title">
                            <h2>Liked Channels</h2>
                        </div>
                    </div>

                    {likedChannels.length === 0 ? (
                        <div className="col-12">
                            <p>No liked channels yet.</p>
                        </div>
                    ) : (
                        likedChannels.map((channel) => (
                            <div className="col-3 col-sm-4 col-lg-1">
                                <div className="album">
                                    <div className="album__cover" key={channel.id} onClick={() => playChannel(channel)}>
                                        <img src={channel.favicon} alt={`${channel.name} logo`} />
                                        <Link role='button' onClick={() => playChannel(channel)}>
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                                <path d="M18.54,9,8.88,3.46a3.42,3.42,0,0,0-5.13,3V17.58A3.42,3.42,0,0,0,7.17,21a3.43,3.43,0,0,0,1.71-.46L18.54,15a3.42,3.42,0,0,0,0-5.92Z" />
                                            </svg>
                                        </Link>
                                    </div>
                                    <div className="album__title">
                                        <h3 className='text-capitalize'><Link to={`/channel/${channel.slug}`}>{channel.name}</Link></h3>
                                        <span className='text-capitalize'><Link to={`/language/${channel.language}`}>{channel.language}</Link></span>
                                    </div>
                                </div>
                            </div>
                        ))
                    )}
                </section>
            </div>
        </main>
        
    );
};

export default LikedChannels;
